import { render, staticRenderFns } from "./Dried.vue?vue&type=template&id=5d8592b4"
import script from "./Dried.vue?vue&type=script&lang=js"
export * from "./Dried.vue?vue&type=script&lang=js"
import style0 from "./Dried.vue?vue&type=style&index=0&id=5d8592b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports